const ZOHO_WEBFORM_URL = "https://crm.zoho.in/crm/WebToLeadForm";
const ZOHO_FORM_ID = "webform1350720000000636003";
const ZOHO_FORM_NAME = "WebToLeads1350720000000636003";

const ZOHO_FIELDS = {
  xnQsjsdp: "0959cfc162a94bde01afd7552740c16a84f4b71e57a0595da14d76d62a653fed",
  zc_gad: "",
  xmIwtLD: "f0a31df26be2e9ec4eb6cd372e8aa5f3b4aedda6bf3cee7baa7b774f38229f25677c7ce98925ccd2315b15f77e0270ed",
  actionType: "TGVhZHM=",
  returnURL: "null",
  aG9uZXlwb3Q: "",
};

const PRODUCT_VALUES = {
  "Machine Clean Millet": "Millet - Machine Clean (Premium)",
  "Bajra (Pearl Millet)": "Millet - Machine Clean (Premium)",
  "Millet - Machine Clean (Premium)": "Millet - Machine Clean (Premium)",
  "Millet - Machine Clean (Regular)": "Millet - Machine Clean (Regular)",
  "Millet - Feed Grade": "Millet - Feed Grade",
  Wheat: "Wheat",
  "Sesbania Seed": "Sesbania Seed",
  "Other / Multiple": "Millet - Feed Grade",
};

export const productValueForZoho = (product) => PRODUCT_VALUES[product] || product || "";

export function submitZohoWebform(inquiry) {
  const form = document.createElement("form");
  form.id = ZOHO_FORM_ID;
  form.name = ZOHO_FORM_NAME;
  form.method = "POST";
  form.action = ZOHO_WEBFORM_URL;
  form.acceptCharset = "UTF-8";
  form.style.display = "none";

  const nameParts = (inquiry.name || "").trim().split(/\s+/).filter(Boolean);
  const lastName = inquiry.last_name?.trim() || nameParts.pop() || "Website enquiry";
  const firstName = inquiry.first_name?.trim() || nameParts.join(" ");

  const values = {
    ...ZOHO_FIELDS,
    "First Name": firstName,
    "Last Name": lastName,
    Company: (inquiry.company_name || "").trim() || "Website enquiry",
    "Address - Country / Region": (inquiry.country || "").trim() || "-None-",
    LEADCF7: PRODUCT_VALUES[inquiry.product_interest] || "-None-",
    LEADCF67: (inquiry.quantity || "").trim(),
    Phone: (inquiry.phone || "").trim(),
    Email: (inquiry.email || "").trim(),
    "Lead Status": inquiry.lead_status || "New",
    LEADCF3: inquiry.buyer_type || "Other",
    Description: (inquiry.message || "").trim(),
  };

  Object.entries(values).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
